import { SCREEN_UNDO_REDO_SET_STATE } from "../actions/types";

const initialState = [];

const screenUndoRedoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCREEN_UNDO_REDO_SET_STATE:
      return action.payload;
    default:
      return state;
  }
};

export default screenUndoRedoReducer;
